import React from 'react';

import styled from 'styled-components';

import StarRating from 'uiToolkit/StarRating';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StarRatingPreview = ({ question }) => (
  <Wrapper>
    <StarRating max={question.answerOptions.length} prevVal={2} size="fixed32px" />
  </Wrapper>
);

export default StarRatingPreview;
